<template>
  <div class="LoaderWrap">
    <Loader />
  </div>
</template>

<script lang="ts">
import Loader from '@/components/elements/Loader.vue'

export default {
  name: 'PageLoader',

  components: {
    Loader
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.LoaderWrap {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 999;
}
</style>
